import classes from "./creditBalance.module.css";
import cx from "classnames";
import useCreditProfileStore from "../../zustandStores/userCreditProfileStore";
import { memo } from "react";
import { numberWithCommas } from "../../services/utils";
import { Routes } from "../../routes/RouteConstants";
import LogService from "../../services/LogService";
import CREDIT_EVENTS from "../../utils/CreditEvents";
import { useRouter } from "next/router";
import Animation from "../../Animations";
import redDot from "../../Animations/lottie-files/redDot.json";
import { JhText } from "designPackages/textPackage";
import { Plus } from "lucide-react";
import {
  JhTooltip,
  JhTooltipContent,
  JhTooltipProvider,
  JhTooltipTrigger
} from "designPackages/toolTip";

const CreditBalance = ({ hideText, view }) => {
  const { data, fetchedState, isCreditBetaUser } = useCreditProfileStore(
    state => ({
      data: state.data,
      fetchedState: state.fetchedState,
      isCreditBetaUser: state.isCreditBetaUser
    })
  );
  const router = useRouter();
  const { totalAvailableCredits = null } = data;
  const centeredClass = "flex justify-center items-center";
  const handleClick = () => {
    if (!window.location.pathname.includes(Routes.PLAN_SELECTION)) {
      LogService.log(CREDIT_EVENTS.BUY_CREDITS_CLICKED, {
        source: "HEADER"
      });
      router.push(`${Routes.PLAN_SELECTION}?eventSource=nav`);
    }
  };
  if (!isCreditBetaUser) {
    return null;
  }
  if (view === "view3" && isCreditBetaUser && fetchedState === "SUCCESS") {
    return (
      <div className="relative flex">
        <div className={cx("flex flex-row items-center", classes.view3)}>
          <span className={cx(centeredClass)}>
            <img
              src="/hire/coin-icon.svg"
              alt="coin"
              height={"25px"}
              width={"25px"}
            />
            <b>{numberWithCommas(totalAvailableCredits)} Credits</b>
          </span>{" "}
        </div>
        <div
          onClick={() => {
            handleClick();
          }}
          className={cx(classes.buyCredits)}
        >
          {totalAvailableCredits == 0 ? `Buy credits` : `Buy more`}
        </div>
        <div className={classes.ripple}>
          <Animation loop file={redDot} />
        </div>
      </div>
    );
  }
  if (view === "view2" && isCreditBetaUser && fetchedState === "SUCCESS") {
    return (
      <div className={cx("flex flex-row items-center", classes.view2)}>
        <span> Credit Balance</span>
        <span className={cx(centeredClass)}>
          <img
            src="/hire/coin-icon.svg"
            alt="coin"
            height={"25px"}
            width={"25px"}
          />
          <b>{numberWithCommas(totalAvailableCredits)}</b>
        </span>{" "}
      </div>
    );
  }
  if (view === "view4" && isCreditBetaUser && fetchedState === "SUCCESS") {
    return (
      <JhTooltipProvider>
        <JhTooltip delayDuration={200}>
          <JhTooltipTrigger asChild>
            <div
              onClick={handleClick}
              className="relative bg-background flex items-center justify-between border px-2 py-1.5 border-slate-200 cursor-pointer rounded-md min-w-fit"
            >
              <div className="flex items-center mr-1">
                <img
                  src="/hire/coin-icon.svg"
                  alt="coin"
                  height={"16px"}
                  width={"16px"}
                  className="mr-1 flex-shrink-0"
                />
                <JhText
                  variant="body2"
                  color="foreground"
                  className="whitespace-nowrap"
                >
                  {numberWithCommas(totalAvailableCredits)}
                  <span className="hidden md:inline"> Credits</span>
                </JhText>
              </div>
              <div className="flex-shrink-0">
                <Plus size={16} />
              </div>
            </div>
          </JhTooltipTrigger>
          <JhTooltipContent className="bg-black  border-black">
            <JhText color="white" variant="caption1">
              Buy Credits
            </JhText>
          </JhTooltipContent>
        </JhTooltip>
      </JhTooltipProvider>
    );
  }
  if (view === "view5" && isCreditBetaUser && fetchedState === "SUCCESS") {
    return (
      <JhTooltipProvider>
        <JhTooltip delayDuration={200}>
          <JhTooltipTrigger asChild>
            <div
              onClick={handleClick}
              className="bg-warning relative flex items-center justify-between p-2  cursor-pointer rounded-2xl min-w-fit"
            >
              <div className="flex items-center mr-1 gap-1">
                <img
                  src="/hire/coin-icon.svg"
                  alt="coin"
                  height={"20px"}
                  width={"20px"}
                  className="flex-shrink-0"
                />
                <JhText
                  variant="body2"
                  color="foreground"
                  className="whitespace-nowrap"
                >
                  {numberWithCommas(totalAvailableCredits)}
                </JhText>
              </div>
              <div className="flex-shrink-0">
                <Plus size={16} />
              </div>
            </div>
          </JhTooltipTrigger>
          <JhTooltipContent variant="primary">
            <JhText color="white" variant="caption1">
              Buy Credits
            </JhText>
          </JhTooltipContent>
        </JhTooltip>
      </JhTooltipProvider>
    );
  }
  return (
    <>
      <div className={cx(classes.balanceRoot, centeredClass)}>
        <div className={cx(classes.creditCnt, centeredClass)}>
          {fetchedState === "SUCCESS"
            ? numberWithCommas(totalAvailableCredits)
            : ""}
          <img
            src="/hire/coin-icon.svg"
            alt="coin"
            height={"25px"}
            width={"25px"}
          />
        </div>
      </div>
    </>
  );
};
export default memo(CreditBalance);
